import {
    SET_MEMBER,
    SET_LICENCES_OF_MEMBER,
} from './mutations-type'

var _ = require('underscore');
var moment = require('moment')
// initial state
const state = {
    member: {
        licences: [],
        licence_active: [],
        log: [],
        file: [],
    },
}

// mutations
const mutations = {
    [SET_MEMBER](state, message) {
        state.member = message;
    },
    [SET_LICENCES_OF_MEMBER](state, message) {
        state.member.licences = message;
    },
}

const actions = {
    setMember({commit}, msg) {
        commit(SET_MEMBER, msg)
    },
    setLicencesOfMember({commit}, msg) {
        commit(SET_LICENCES_OF_MEMBER, msg)
    },
}

const getters = {
    getMember: state => {
        return state.member;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-member.js